import { render, staticRenderFns } from "./ReferralInfoModal.vue?vue&type=template&id=6b0aff6e&scoped=true&"
import script from "./ReferralInfoModal.vue?vue&type=script&lang=js&"
export * from "./ReferralInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./ReferralInfoModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReferralInfoModal.vue?vue&type=style&index=1&id=6b0aff6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0aff6e",
  null
  
)

export default component.exports